import * as React from 'react';

var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgConfirmedFilled24 = function SvgConfirmedFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m18.126 7.168-7.685 8.645-4.628-3.704a.504.504 0 0 0-.704.079.502.502 0 0 0 .079.703l5 4c.005.004.013.002.019.006.088.065.19.103.293.103a.497.497 0 0 0 .207-.047c.022-.01.038-.029.059-.042.037-.024.077-.044.108-.079l8-9a.5.5 0 1 0-.748-.664z",
    fill: "#fff"
  })));
};

var ConfirmedFilled24Svg = SvgConfirmedFilled24;

export { ConfirmedFilled24Svg as default };
//# sourceMappingURL=ConfirmedFilled24.svg.js.map
